import { TeaserLinkItemProps } from 'libs/contentful/props';
import Media from 'components/shared/Media/Media';
import { cn } from 'utils/styles';
import BaseTeaserLinkItem, { TeaserLinkContent } from './BaseTeaserLinkCard';

const IconTeaserLink = ({ image, linkText, internalPage, url }: TeaserLinkItemProps) => {
  return (
    <BaseTeaserLinkItem url={url} internalPage={internalPage} className="white-colorway px-6 pt-6 pb-4 gap-6 ">
      <div className={'h-24 w-24 flex-none'}>
        <Media media={{ ...image!, description: '' }} className={cn('rounded-none object-contain')} />
      </div>
      <TeaserLinkContent>{linkText}</TeaserLinkContent>
    </BaseTeaserLinkItem>
  );
};

export default IconTeaserLink;
